import React from 'react';
import { Segmented } from 'antd';
import { PRIORITY_OPTIONS } from '../constants';

const PrioritySelector = ({ value, onChange, style = {} }) => {
  return (
    <Segmented
      options={PRIORITY_OPTIONS.map(p => ({
        label: (
          <div style={{ textAlign: 'center', minWidth: '60px' }}>
            <div style={{ fontSize: '12px' }}>{p.icon}</div>
            <div style={{ fontSize: '10px', marginTop: '2px' }}>{p.label}</div>
          </div>
        ),
        value: p.value,
      }))}
      value={value}
      onChange={onChange}
      style={{ 
        width: '100%',
        background: '#f5f5f5',
        borderRadius: '6px',
        padding: '4px',
        ...style
      }}
    />
  );
};

export default PrioritySelector;
